import { render, staticRenderFns } from "./PortfolioFilterLink.vue?vue&type=template&id=6c9df824&scoped=true&"
import script from "./PortfolioFilterLink.vue?vue&type=script&lang=js&"
export * from "./PortfolioFilterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9df824",
  null
  
)

export default component.exports